'use strict';

const RECOMMENDATIONS_HEART_EMPTY = 'recommendations-heart-empty';
const RECOMMENDATIONS_HEART_FULL = 'recommendations-heart-full';
const RECOMMENDATIONS_FULL_ICON = 'recommendations-full_icon';
const RECOMMENDATIONS_CHEVRON = 'recommendations-chevron';
const RECOMMENDATIONS_START_EMPTY = 'recommendations-star-empty';
const RECOMMENDATIONS_START_HALF = 'recommendations-star-half';
const RECOMMENDATIONS_START_FULL = 'recommendations-star-full';
const RECOMMENDATIONS_MELI_LOGO = 'recommendations-meli_logo';
const RECOMMENDATIONS_MELI_COINS = 'recommendations-meli_coins';
const RECOMMENDATIONS_CPG_ICON = 'recommendations-cpg_icon';
const RECOMMENDATIONS_CBT_ICON = 'recommendations-cbt_icon';
const RECOMMENDATIONS_BLACK_FRIDAY_ICON = 'recommendations-black-friday_icon';
const RECOMMENDATIONS_MELICHOICE_LOGO = 'recommendations-melichoice_logo';
const RECOMMENDATIONS_BUFLO_ICON_INFO = 'recommendations-buflo_icon_info';
const RECOMMENDATIONS_MSHOPS_LOGO = 'recommendations-mshops_logo';
const RECOMMENDATIONS_CLOCK_ICON = 'recommendations-clock_icon';
const RECOMMENDATIONS_STORE_ICON = 'recommendations-store_icon';
const RECOMMENDATIONS_FIRE_ICON = 'recommendations-fire_icon';
const RECOMMENDATIONS_BADGE_ICON = 'recommendations-badge_icon';
const RECOMMENDATIONS_INFO_ICON = 'recommendations-info_icon';
const RECOMMENDATIONS_APPAREL_ICON = 'recommendations-clothing_icon';
const RECOMMENDATIONS_BEAUTY_ICON = 'recommendations-beauty_icon';
const RECOMMENDATIONS_TOOLS_ICON = 'recommendations-tools_icon';
const RECOMMENDATIONS_SUPERMARKET_ICON = 'recommendations-super_icon';
const RECOMMENDATIONS_DECO_ICON = 'recommendations-furniture_icon';
exports.RECOMMENDATIONS_APPAREL_ICON = RECOMMENDATIONS_APPAREL_ICON;
exports.RECOMMENDATIONS_BADGE_ICON = RECOMMENDATIONS_BADGE_ICON;
exports.RECOMMENDATIONS_BEAUTY_ICON = RECOMMENDATIONS_BEAUTY_ICON;
exports.RECOMMENDATIONS_BLACK_FRIDAY_ICON = RECOMMENDATIONS_BLACK_FRIDAY_ICON;
exports.RECOMMENDATIONS_BUFLO_ICON_INFO = RECOMMENDATIONS_BUFLO_ICON_INFO;
exports.RECOMMENDATIONS_CBT_ICON = RECOMMENDATIONS_CBT_ICON;
exports.RECOMMENDATIONS_CHEVRON = RECOMMENDATIONS_CHEVRON;
exports.RECOMMENDATIONS_CLOCK_ICON = RECOMMENDATIONS_CLOCK_ICON;
exports.RECOMMENDATIONS_CPG_ICON = RECOMMENDATIONS_CPG_ICON;
exports.RECOMMENDATIONS_DECO_ICON = RECOMMENDATIONS_DECO_ICON;
exports.RECOMMENDATIONS_FIRE_ICON = RECOMMENDATIONS_FIRE_ICON;
exports.RECOMMENDATIONS_FULL_ICON = RECOMMENDATIONS_FULL_ICON;
exports.RECOMMENDATIONS_HEART_EMPTY = RECOMMENDATIONS_HEART_EMPTY;
exports.RECOMMENDATIONS_HEART_FULL = RECOMMENDATIONS_HEART_FULL;
exports.RECOMMENDATIONS_INFO_ICON = RECOMMENDATIONS_INFO_ICON;
exports.RECOMMENDATIONS_MELICHOICE_LOGO = RECOMMENDATIONS_MELICHOICE_LOGO;
exports.RECOMMENDATIONS_MELI_COINS = RECOMMENDATIONS_MELI_COINS;
exports.RECOMMENDATIONS_MELI_LOGO = RECOMMENDATIONS_MELI_LOGO;
exports.RECOMMENDATIONS_MSHOPS_LOGO = RECOMMENDATIONS_MSHOPS_LOGO;
exports.RECOMMENDATIONS_START_EMPTY = RECOMMENDATIONS_START_EMPTY;
exports.RECOMMENDATIONS_START_FULL = RECOMMENDATIONS_START_FULL;
exports.RECOMMENDATIONS_START_HALF = RECOMMENDATIONS_START_HALF;
exports.RECOMMENDATIONS_STORE_ICON = RECOMMENDATIONS_STORE_ICON;
exports.RECOMMENDATIONS_SUPERMARKET_ICON = RECOMMENDATIONS_SUPERMARKET_ICON;
exports.RECOMMENDATIONS_TOOLS_ICON = RECOMMENDATIONS_TOOLS_ICON;
